export default __webpack_public_path__ + "static/media/Host-2.076cbf2e.png";